import type { ICampaignManagementLineItem } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { NEW_ITEM_ID } from '@/constants/campaignManagement';

export const getLineItemActivationConditions = (
  lineItem: Partial<Pick<ICampaignManagementLineItem, 'creativesCount' | 'id'>> | undefined,
) => [
  { condition: 'General', checked: !!lineItem?.id && `${lineItem?.id}` !== NEW_ITEM_ID },
  { condition: 'Targeting', checked: !!lineItem?.id && `${lineItem?.id}` !== NEW_ITEM_ID },
  { condition: 'Creative Association', checked: (lineItem?.creativesCount ?? 0) > 0 },
];
